export default "__VITE_ASSET__BzuOsrBy__"